"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogActionType = void 0;
var LogActionType;
(function (LogActionType) {
    LogActionType["ENABLE_AUTO_PAYMENT"] = "ENABLE_AUTO_PAYMENT";
    LogActionType["DISABLE_AUTO_PAYMENT"] = "DISABLE_AUTO_PAYMENT";
    LogActionType["REMOVE_CARD"] = "REMOVE_CARD";
    LogActionType["ADDON_ENABLE_AUTO_PAYMENT"] = "ADDON_ENABLE_AUTO_PAYMENT";
    LogActionType["ADDON_DISABLE_AUTO_PAYMENT"] = "ADDON_DISABLE_AUTO_PAYMENT";
    LogActionType["REMOVE_SUBSCRIPTION"] = "REMOVE_SUBSCRIPTION";
})(LogActionType || (exports.LogActionType = LogActionType = {}));
//# sourceMappingURL=log-action-type.enum.js.map